import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';

export const SectionContainer = styled(Box)`
  width: 100%;
  position: relative;
  min-height: 693px;
  ${themeMediaQuery('below_sm')} {
    min-height: 657px;
  }
  ${themeMediaQuery('md')} {
    min-height: 839px;
  }
`;

export const TextPairingContainer = styled(TextPairing)`
  margin-top: calc(${themeSpace(11)} + ${themeSpace(5)});
  ${themeMediaQuery('below_sm')} {
    margin-top: calc(${themeSpace(12)} + ${themeSpace(4)});
    .text-pairing-title {
      font-size: ${themeSpace(8)};
    }
  }
  .text-pairing-body {
    max-width: 330px;
  }
  ${themeMediaQuery('tablet')} {
    .text-pairing-eyebrow {
      margin-top: ${themeSpace(11)};
    }
  }
`;

export const StyledTextPairFlex = styled(Flex)`
  width: 100%;
  align-items: center;
`;

export const StyledBottomImageWrapper = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 0rem;
    padding-right: 0rem;
  }
`;

export const StyledLeftImage = styled(CloudImage)`
  position: absolute;
  width: 187px;
  height: 606px;
  bottom: 0;
  object-fit: contain;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledRightImage = styled(CloudImage)`
  position: absolute;
  width: 162px;
  height: 610px;
  top: 37px;
  right: 0;
  object-fit: contain;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledMobileImage = styled(CloudImage)`
  position: absolute;
  width: 100%;
  top: 0;
  object-fit: contain;
  ${themeMediaQuery('sm')} {
    display: none;
  }
  ${themeMediaQuery('tablet')} {
    max-height: 188px;
    width: 100%;
    object-fit: cover;
    overflow: hidden;
    object-position: bottom;
  }
`;

export const VideoWrapper = styled(Box)`
  width: 720px;
  height: 251px;
  margin-top: ${themeSpace(8)};
  ${themeMediaQuery('below_sm')} {
    width: 375px;
    height: 143px;
  }
  ${themeMediaQuery('tablet')} {
    width: 568px;
    height: 216px;
  }
  ${themeMediaQuery('md')} {
    width: 1152px;
    height: 392px;
  }
`;

export const BackgroundGradient = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 335px;
  background: linear-gradient(180deg, #fff8f7 0%, rgba(255, 248, 247, 0) 80.08%);
  z-index: -1;
`;
